import { DESKTOP_THRESHOLD } from '../../../config/constants';
import type { RiveFTUEConfig } from '../../../services/types';

export type FtueViewType = 'desktop' | 'mobile';

export function getFtueViewType(): FtueViewType {
  return window.parent.innerWidth > DESKTOP_THRESHOLD ? 'desktop' : 'mobile';
}

export function getRiveFtueFileConfig(config: RiveFTUEConfig, viewType?: FtueViewType) {
  return viewType === 'desktop' ? config?.desktop : config?.mobile_web || config?.mobile_m;
}
